import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence, useScroll, useSpring } from 'framer-motion';
import { Lock, ShieldCheck, Zap } from 'lucide-react';
export function LuxuryStickyBar() {
  const [isVisible, setIsVisible] = useState(false);
  const {
    scrollYProgress
  } = useScroll();
  const scaleX = useSpring(scrollYProgress, {
    stiffness: 100,
    damping: 30,
    restDelta: 0.001
  });
  useEffect(() => {
    const handleScroll = () => {
      setIsVisible(window.scrollY > 600);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const scrollToCTA = () => {
    const cta = document.getElementById('cta-section');
    if (cta) cta.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <>
      {/* Scroll progress bar */}
      <motion.div className="fixed top-0 left-0 right-0 h-[3px] origin-left z-[51]" style={{
      scaleX,
      background: 'var(--accent)'
    }} data-id="element-156" />

      {/* Floating bottom CTA bar */}
      <AnimatePresence data-id="element-157">
        {isVisible && <motion.div initial={{
        y: 100,
        opacity: 0
      }} animate={{
        y: 0,
        opacity: 1
      }} exit={{
        y: 100,
        opacity: 0
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 30
      }} className="fixed bottom-0 left-0 right-0 z-40" data-id="element-158">
            {/* Gradient fade edge */}
            <div className="h-6 bg-gradient-to-t from-[var(--bg-card)] to-transparent pointer-events-none opacity-90" data-id="element-159" />

            <div className="bg-[var(--bg-card)]/95 backdrop-blur-md border-t border-[var(--border-subtle)] shadow-[0_-4px_30px_rgba(0,0,0,0.08)]" data-id="element-160">
              <div className="max-w-[580px] mx-auto px-4 py-3 flex items-center gap-3" data-id="element-161">
                {/* Book thumbnail */}
                <img src="https://cdn.magicpatterns.com/uploads/xdkdFJBsvzWQikawQ8nDi2/heylloyd-image-1772934658127.png" alt="Sensory Feeding Victory" className="w-10 h-14 rounded object-cover border border-[var(--border-subtle)] shadow-sm flex-shrink-0 hidden sm:block" data-id="element-162" />

                {/* Price info */}
                <div className="flex-shrink-0 hidden sm:block" data-id="element-163">
                  <p className="text-[10px] text-[var(--text-muted)] uppercase tracking-wider leading-none" data-id="element-164">
                    Complete Bundle
                  </p>
                  <div className="flex items-baseline gap-1.5" data-id="element-165">
                    <span className="text-[var(--text-muted)] line-through text-xs opacity-70" data-id="element-166">
                      $225
                    </span>
                    <span className="text-[var(--text-heading)] font-serif font-bold text-lg leading-none" data-id="element-167">
                      $27
                    </span>
                  </div>
                </div>

                {/* CTA Button */}
                <motion.button onClick={scrollToCTA} whileTap={{
              scale: 0.97
            }} className="flex-1 py-3 px-4 bg-[var(--accent)] hover:bg-[var(--accent-hover)] text-white font-bold text-sm rounded-lg flex items-center justify-center gap-2 shadow-md relative overflow-hidden group whitespace-nowrap transition-colors" data-id="element-168">
                  <span className="absolute inset-0 -translate-x-full group-hover:translate-x-full transition-transform duration-700 bg-gradient-to-r from-transparent via-white/20 to-transparent" data-id="element-169" />
                  <Lock className="w-3.5 h-3.5 relative z-10 flex-shrink-0" data-id="element-170" />
                  <span className="relative z-10 uppercase tracking-wide text-xs sm:text-sm" data-id="element-171">
                    GET ACCESS NOW — $6.99
                  </span>
                </motion.button>
              </div>

              {/* Trust micro-badges */}
              <div className="flex items-center justify-center gap-4 pb-3 text-[9px] text-[var(--text-muted)]" data-id="element-172">
                <span className="flex items-center gap-1" data-id="element-173">
                  <ShieldCheck className="w-2.5 h-2.5 text-[var(--accent)]" data-id="element-174" />{' '}
                  30-Day Guarantee
                </span>
                <span className="opacity-30" data-id="element-175">·</span>
                <span className="flex items-center gap-1" data-id="element-176">
                  <Zap className="w-2.5 h-2.5 text-[var(--accent)]" data-id="element-177" /> Instant
                  Download
                </span>
                <span className="opacity-30" data-id="element-178">·</span>
                <span className="flex items-center gap-1" data-id="element-179">
                  <Lock className="w-2.5 h-2.5 text-[var(--accent)]" data-id="element-180" /> Secure
                  Payment
                </span>
              </div>
            </div>
          </motion.div>}
      </AnimatePresence>
    </>;
}